import { GzAntimalwareExclusionsListsWebComponent } from './component/GzAntimalwareExclusionsListsWebComponent';

export { GzAntimalwareExclusionsListsWebComponent };
